<template>
  <div class="pillar-modal">
    <div
      ref="bodyEl"
      v-html="bodyHTML"
    />
  </div>
</template>

<script setup>
import {
  nextTick,
  onMounted,
  onUnmounted,
  ref,
} from 'vue';
import { metricsLink } from '../../../utils/analytics';

const bodyEl = ref(null);

defineProps({
  heading: {
    type: String,
    required: true,
  },
  bodyHTML: {
    type: String,
    required: true,
  },
});

const handleClickNative = (el) => {
  const payload = { linkName: 'pillar modal link' };
  if (el && el.innerHTML) payload.linkName = el.innerHTML;
  metricsLink(payload);
};

onMounted(() => {
  nextTick(() => {
    if (bodyEl.value && typeof bodyEl.value.querySelectorAll === 'function') {
      bodyEl.value.querySelectorAll('a').forEach((el) => {
        el.addEventListener('click', handleClickNative);
      });
    }
  });
});
onUnmounted(() => {
  if (bodyEl.value && typeof bodyEl.value.querySelectorAll === 'function') {
    bodyEl.value.querySelectorAll('a').forEach((el) => {
      el.removeEventListener('click', handleClickNative);
    });
  }
});
</script>

<style lang="scss">
.pillar-modal {
  a {
    @include cdr-link-base-mixin;
  }
  strong {
    font-weight: $cdr-text-body-strong-300-weight;
  }
  ul {
    @include cdr-list-base-mixin;
    @include cdr-list-unordered-mixin;
    @include cdr-list-compact-mixin;
  }
}

.mem-modal--pillar {
  [class^=cdr-modal__title] {
    h1 {
      margin: 0;
      @include cdr-text-heading-serif-700;
    }
  }
}
</style>
